import { Injectable } from "@angular/core";
import { documentType } from "../models/cotizador/response/model.data.response";

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    setItem(name: string, value: documentType[]) {
        window.sessionStorage.setItem(name, JSON.stringify(value));
    }

    getItem(name: string) {
        const item = window.sessionStorage.getItem(name);
        return item ? JSON.parse(item) : null;
    }
    

    remove(name: string) {
        window.sessionStorage.removeItem(name);
    }
}